/** Links de compartilhamento por rede — funções puras, testadas. */

export type ShareTarget = 'whatsapp' | 'telegram' | 'linkedin' | 'facebook' | 'x' | 'email';

export function shareUrl(target: ShareTarget, url: string, text: string): string {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  switch (target) {
    case 'whatsapp':
      return `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;
    case 'telegram':
      return `https://t.me/share/url?url=${u}&text=${t}`;
    case 'linkedin':
      return `https://www.linkedin.com/sharing/share-offsite/?url=${u}`;
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${u}`;
    case 'x':
      return `https://twitter.com/intent/tweet?url=${u}&text=${t}`;
    case 'email':
      return `mailto:?subject=${t}&body=${encodeURIComponent(`${text}\n\n${url}`)}`;
  }
}

/** Mesma URL, começando num ponto do vídeo (`?t=192`). */
export function withStartTime(url: string, seconds: number | null): string {
  const u = new URL(url);
  if (seconds && seconds > 0) u.searchParams.set('t', String(Math.floor(seconds)));
  else u.searchParams.delete('t');
  return u.toString();
}
